import cookie from 'cookie';
import type { IncomingMessage } from 'http';

import BaseAxiosRequest from '@r1-frontend/do-request/core/BaseAxiosRequest';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';
import { AGREEMENT_NUMBER } from '@r1-frontend/shared/helpers/getAgreementNumber';
import { PROVIDER_ID_COOKIE } from '@r1-frontend/shared/helpers/getProviderId';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';
import { IRequest } from '@r1-frontend/shared/types/IRequest';

class SSRAxiosRequest extends BaseAxiosRequest {
    private readonly requestCookies: Record<string, string> = {};
    private readonly requestUrl: string | undefined;

    constructor(
        req: IncomingMessage,
    ) {
        super();

        this.requestCookies = cookie.parse(req.headers?.cookie || '');
        this.requestUrl = req.url;
    }

    private getCookie(name: string) {
        return this.requestCookies[name] || undefined;
    }

    protected getDefaultHeaders(withAuth: IRequest['withAuth'], withProvider: IRequest['withProvider']): IRequest['headers'] {
        const defaultHeaders: IRequest['headers'] = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        };

        const accessToken = this.getCookie(ACCESS_TOKEN_COOKIE);
        if (withAuth && Boolean(accessToken)) {
            defaultHeaders['Authorization'] = `Bearer ${accessToken}`;

            const agreementNumber = this.getCookie(AGREEMENT_NUMBER);
            if (agreementNumber) {
                defaultHeaders['agreementNumber'] = agreementNumber;
            } else if (isServerSide()) {
                console.log(JSON.stringify({ event: 'Empty agreementNumber', url: this.requestUrl, ...this.requestCookies }));
            }
        }

        const providerId = this.getCookie(PROVIDER_ID_COOKIE);
        if (withProvider && providerId) {
            defaultHeaders['ProviderId'] = providerId;
        }

        return defaultHeaders;
    }
}

export default SSRAxiosRequest;
